import { Box, Flex } from "@chakra-ui/react";
import { GetLayout } from "components/get-layout";
import { useState } from "react";
import { Tab, Tabs } from "components/tabs";
import { CampanhasWhatsAppAntiga } from "components/campanha-whatsapp-components/campanhas-deprecated";
import { CampanhasWhatsAppNova } from "components/campanha-whatsapp-components/campanhas-novo-formato";

export type WhatsAppTabsEnum = "campanhas" | "campanhas-novo-formato";

export default function CampanhaNova() {
  const [activeTab, setActiveTab] = useState<WhatsAppTabsEnum>("campanhas");

  const tabs: Tab<WhatsAppTabsEnum>[] = [
    { name: "Campanhas", key: "campanhas" },
    { name: "Campanhas (Novo formato)", key: "campanhas-novo-formato" }
  ];

  return (
    <>
      <GetLayout pageContentProps={{ p: "0px" }}>
        {/* <Flex
          w="100%"
          bg="#fff"
          h="55px"
          borderBottom="1px solid #E8EAED"
          justifyContent="space-between"
          alignItems="center"
        >
          <Tabs activeTab={activeTab} onChangeTab={setActiveTab} tabs={tabs} />
        </Flex> */}
        <Box w="100%" p="30px">
          <CampanhasWhatsAppNova />
          {/* {activeTab === "campanhas" ? (
            <CampanhasWhatsAppAntiga setActiveTab={setActiveTab} />
          ) : (
            <CampanhasWhatsAppNova />
          )} */}
        </Box>
      </GetLayout>
    </>
  );
}
